<template>
  <div>
    <h2 class="content-block">
      Balance for {{ comparisonSourceName }}
    </h2>
    <b-form class="dx-card wide-card form" @submit.stop.prevent="updateGraphs">
      <b-row>
        <b-col>
          <date-range :date-range="dateRange" @dateUpdate="dateUpdate" />
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end mt-3">
        <div>
          <b-button
            slot="finish"
            type="submit"
            :disabled="loading"
            variant="primary"
          >
            View balance changes
            <span
              v-if="loading"
              class="fa fa-spinner fa-pulse fa-fw ml-2"
            /><span v-else class="fa fa-search fa-fw ml-2" />
          </b-button>
        </div>
      </div>
    </b-form>
    <div v-if="!!dataSource && !loading">
      <DxChart id="chart" :data-source="dataSource" palette="Violet">
        <DxCommonSeriesSettings type="line" argument-field="time" />
        <DxSeries key="reported" value-field="reported" name="Reported" />
        <DxSeries key="calculated" value-field="calculated" name="Calculated" />
        <DxMargin :bottom="20" />
        <DxArgumentAxis
          :value-margins-enabled="false"
          discrete-axis-division-mode="crossLabels"
          argument-type="datetime"
        >
          <DxGrid :visible="true" />
        </DxArgumentAxis>
        <DxLegend
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="bottom"
        />
        <DxExport :enabled="true" />
        <DxTitle :text="'Balance movement for ' + comparisonSourceName">
          <DxSubtitle :text="'In ' + currencyName" />
        </DxTitle>
        <DxTooltip :enabled="true" :format="config.financialNumberFormat" />
      </DxChart>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import {DxArgumentAxis, DxChart, DxCommonSeriesSettings, DxExport, DxGrid, DxLegend, DxMargin, DxSeries, DxSubtitle, DxTitle, DxTooltip,} from 'devextreme-vue/chart'
import {DxTagBox} from 'devextreme-vue'
import {http, showHttpError} from '@/utils/http'
import DateRange from '@/components/date-range'
import {config} from '@/config'

export default {
  name: 'ViewStatements',
  components: {
    DateRange,
    DxExport,
    // eslint-disable-next-line vue/no-unused-components
    DxTagBox,
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxGrid,
    DxMargin,
    DxLegend,
    DxTitle,
    DxSubtitle,
    DxTooltip,
  },
  data() {
    return {
      config,

      gateway: this.$route.params.gateway,
      source: this.$route.params.source,
      comparisonSourceName: null,
      currencyName: null,

      loading: false,

      dataSource: null,

      dateRange: {
        startDate: new Date(new Date().getTime() - 7 * config.oneDay),
        endDate: new Date(),
      },
    }
  },
  computed: {
    ...mapState('user', ['gatewayLookup', 'currencyLookup']),
  },
  created() {
    this.comparisonSourceName = this.gatewayLookup[this.gateway].sources[this.source].name
  },
  destroyed() {},
  methods: {
    async updateGraphs() {
      let response
      this.loading = true
      try {
        response = await http
          .get('reconciliation/admin/balance/' + this.gateway + '/' + this.source, {
            searchParams: {
              from: this.dateRange.startDate.getTime(),
              to: this.dateRange.endDate.getTime(),
            },
          })
          .json()
        this.currencyName = this.currencyLookup[response.currencyId].iso
        this.dataSource = response.points
      } catch (e) {
        return await showHttpError(e)
      } finally {
        this.loading = false
      }
    },
    dateUpdate(dateRange) {
      this.dateRange = Object.assign({}, this.dateRange, dateRange)
    },
  },
}
</script>
<style lang="scss">
td[role='columnheader'] {
  text-align: center !important;
}
</style>
